/* eslint-disable react/self-closing-comp */
import React, { useState, useEffect } from 'react'
import { ReactComponent as DoneIcon } from '../../assests/svg/done.svg'
import { ReactComponent as CloseIcon } from '../../assests/svg/close.svg'
import './Message.scss'

export default function Message({
  errorMessage,
  type,
  showMessage,
  setShowMessage
}) {
  const [message, setMessage] = useState('')
  const [icon, setIcon] = useState(<div></div>)

  useEffect(() => {
    messageType(type)
  }, [type, errorMessage])

  const messageType = (type) => {
    let showMesg = true
    let message = ''
    let icon = <div></div>

    switch (type) {
      case 'loading': {
        message = 'Loading...'
        icon = <div className='veyetals-view-loader'></div>
        break
      }
      case 'doneLoading': {
        message = 'Loading...'
        icon = <div className='veyetals-view-loader'></div>
        setTimeout(() => setShowMessage(false), 2000)
        break
      }
      case 'start': {
        message = 'Scan Starting...'
        icon = <div className='veyetals-view-loader'></div>
        break
      }
      case 'scanning': {
        message = 'Scanning, please wait...'
        icon = <div className='veyetals-view-loader'></div>
        break
      }
      case 'complete': {
        message = 'Scan Completed!'
        icon = <DoneIcon className='veyetals-view-message__icon--done' />
        break
      }
      case 'loadingFaceTracking': {
        message = 'Loading face tracking, please wait before starting scan'
        icon = <div className='veyetals-view-loader'></div>
        break
      }
      case 'doneLoadingFaceTracking': {
        message = 'Loading face tracking, please wait before starting scan'
        icon = <div className='veyetals-view-loader'></div>
        setTimeout(() => setShowMessage(false), 3000)
        break
      }
      case 'error': {
        message = errorMessage
        icon = <CloseIcon className='veyetals-view-message__icon--close' />
        break
      }
      default: {
        message = ''
        icon = <div></div>
        showMesg = false
        break
      }
    }
    setShowMessage(showMesg)
    setMessage(message)
    setIcon(icon)
  }

  return (
    <div className='veyetals-view-message'>
      {showMessage && (
        <div className='veyetals-view-message__container'>
          {icon}
          <p className='veyetals-view-message__text'>{message}</p>
        </div>
      )}
    </div>
  )
}
